import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { TrendingUp, Award, Target, Repeat, Bell } from 'lucide-react';
const features = [{
  icon: TrendingUp,
  title: 'Progresso visual e contínuo',
  description: 'Gráficos claros que mostram a evolução do aluno treino a treino.'
}, {
  icon: Award,
  title: 'Reconhecimento individual',
  description: 'Medalhas e conquistas automáticas para marcos importantes.'
}, {
  icon: Target,
  title: 'Gamificação saudável',
  description: 'Sistema opcional de níveis e desafios para motivar sem constranger.'
}, {
  icon: Repeat,
  title: 'Funil automático de retenção',
  description: 'Processos automatizados para manter o aluno ativo e frequente.'
}, {
  icon: Bell,
  title: 'Recuperação inteligente',
  description: 'Alertas para alunos inativos antes que eles cancelem o plano.'
}];
export function SolutionSection() {
  return <Section data-id="element-151">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} data-id="element-153">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-6" data-id="element-154">
            Aqui, o esforço do aluno vira{' '}
            <span className="text-[#FF6B35]" data-id="element-155">reconhecimento</span>
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-156">
            Um sistema único que permite ao aluno acompanhar sua evolução, se
            sentir reconhecido e motivado — enquanto a academia ganha retenção,
            engajamento e previsibilidade.
          </p>

          <div className="space-y-6" data-id="element-157">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-158">
                <div className="mt-1 bg-orange-50 p-2 rounded-lg" data-id="element-159">
                  <feature.icon className="h-5 w-5 text-[#FF6B35]" data-id="element-160" />
                </div>
                <div data-id="element-161">
                  <h3 className="font-bold text-[#2D3748]" data-id="element-162">{feature.title}</h3>
                  <p className="text-gray-600 text-sm" data-id="element-163">{feature.description}</p>
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="relative" data-id="element-164">
          <div className="bg-[#2D3748] rounded-2xl p-8 shadow-2xl relative overflow-hidden" data-id="element-165">
            {/* Abstract Dashboard Visual */}
            <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-166">
              <div className="bg-gray-700/50 p-4 rounded-xl h-32 animate-pulse" data-id="element-167"></div>
              <div className="bg-gray-700/50 p-4 rounded-xl h-32 animate-pulse delay-75" data-id="element-168"></div>
            </div>
            <div className="bg-gray-700/50 p-4 rounded-xl h-48 mb-4 animate-pulse delay-150" data-id="element-169"></div>
            <div className="flex gap-4" data-id="element-170">
              <div className="bg-[#FF6B35] h-12 w-full rounded-lg opacity-90" data-id="element-171"></div>
            </div>

            {/* Floating Elements */}
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded-xl shadow-xl text-center min-w-[240px]" data-id="element-172">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-173">
                <Award className="h-8 w-8 text-[#FF6B35]" data-id="element-174" />
              </div>
              <h4 className="font-bold text-gray-900 text-lg" data-id="element-175">Parabéns!</h4>
              <p className="text-gray-600 text-sm" data-id="element-176">Você atingiu o nível Ouro</p>
            </div>
          </div>

          {/* Background decoration */}
          <div className="absolute -z-10 top-10 -right-10 w-full h-full border-2 border-orange-200 rounded-2xl" data-id="element-177"></div>
        </motion.div>
      </div>
    </Section>;
}